import type { Directive } from 'vue'

// Adds a fade-up entrance when the element first scrolls into view.
// Falls back to always-visible when IntersectionObserver is missing or
// the user prefers reduced motion.
export const reveal: Directive<HTMLElement> = {
  mounted(el) {
    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return
    }

    el.classList.add('opacity-0')
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          el.classList.remove('opacity-0')
          el.classList.add('animate-fade-up')
          observer.disconnect()
        }
      },
      { threshold: 0.1 },
    )
    observer.observe(el)
  },
}
